export default __webpack_public_path__ + "img/img4.8c64cfad.png";